import _ from "lodash";
import {store} from "@/plugins/vuex";
import i18n from "@/shared/i18n";
import i18nHelper from "@/core/services/i18n.service";
import cloneDeep from "lodash/cloneDeep";

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */

const searchNested = (array, key, attr, childAttr) => {
  let node
  array.some(object => node = object[attr] === key ? object : searchNested(object[childAttr], key, attr, childAttr))
  return node
}

export default {
  handleErrors(arr, responseBody) {
    Object.keys(responseBody).forEach((key) => {
      if (typeof responseBody[key] === 'object') {
        const innerObject = responseBody[key];
        Object.keys(innerObject).forEach((innerKey) => {
          if (typeof innerObject[innerKey] === 'object') {
            innerObject[innerKey].forEach((errorMessage) => {
              arr.push(errorMessage);
            });
          } else {
            arr.push(innerObject[innerKey]);
          }
        });
      } else if (typeof responseBody[key] === 'string') {
        arr.push(responseBody[key]);
      } else {
        responseBody[key].forEach((errorMessage) => {
          arr.push(errorMessage);
        });
      }
    });
    return arr;
  },
  isMobileDevice() {
    return window.innerWidth <= 992;
  },
  sortDynamicFieldsTemplate(dynamic_fields_template) {
    return _.orderBy(Object.keys(dynamic_fields_template).map(key => {
      return {key, ...dynamic_fields_template[key]}
    }), ['position'], ['asc'])
  },
  calculateDynamicFieldsTemplateFromFields(dynamicFields, skipEmptyFields = false) {
    if (store && store.state && store.state.global) {
      let masterLanguage = i18nHelper.getMasterLanguage()
      let dynamicFieldsTemplate = {}
      if (dynamicFields[masterLanguage.key]) {
        for (let dfKey in dynamicFields[masterLanguage.key]) {
          if (skipEmptyFields && !dynamicFields[masterLanguage.key][dfKey]) {
            continue;
          }
          if (store.state.global.uniqueDynamicFields[dfKey]) {
            dynamicFieldsTemplate[dfKey] = {
              key: dfKey,
              ...cloneDeep(store.state.global.uniqueDynamicFields[dfKey])
            }
          }
        }
      }
      return dynamicFieldsTemplate
    }
    return {}
  },
  calculateTiers(data, tax_rate = null) {
    if (store && store.state && store.state.global.inclusiveTiersEnabled) {
      tax_rate = tax_rate ? tax_rate : store.state.global.currentBranch.tax_rate;
      if (data.commissions) {
        for (let c of data.commissions) {
          c.percent = parseFloat(c.percent / (tax_rate / 100 + 1)).toFixed(8)
        }
      }
      if (data.premiums) {
        for (let p of data.premiums) {
          p.percent = parseFloat(p.percent / (tax_rate / 100 + 1)).toFixed(8)
        }
      }
    }
    return data
  },
  reverseCalculateTiers(data, tax_rate = null) {
    if (!data) {
      return data
    }

    if (store && store.state && store.state.global.inclusiveTiersEnabled) {
      tax_rate = tax_rate ? tax_rate : store.state.global.currentBranch.tax_rate;
      if (data.commissions) {
        for (let c of data.commissions) {
          c.percent = Math.round(parseFloat(c.percent * (tax_rate / 100 + 1)))
        }
      }
      if (data.premiums) {
        for (let p of data.premiums) {
          p.percent = Math.round(parseFloat(p.percent * (tax_rate / 100 + 1)))
        }
      }
    }

    return data;
  },
  orderDatesByKey(arr, key, asc = true) {
    return arr.sort(function (a, b) {
      let keyA = new Date(a[key]),
        keyB = new Date(b[key]);
      if (keyA < keyB) return asc ? -1 : 1;
      if (keyA > keyB) return asc ? 1 : -1;
      return 0;
    });
  },
  getLotIncrementStep(lot, saleIncrements) {
    if (lot.increments.length) {
      return lot.increments[0].increment;
    }
    const checkAgainst = lot.reserve ? lot.reserve : lot.start_price;
    for (let i = 0; i < saleIncrements.length; i++) {
      let increment = saleIncrements[i];
      if (!increment.max || increment.max > checkAgainst) {
        return increment.increment;
      }
    }
    return saleIncrements.length ? saleIncrements[0].increment : null;
  },
  /**
   * Default for cataloguing_lifecycle_options / photography_lifecycle_options JSON:
   * {key, value, default?}. default is optional (omit/false = not default).
   * At most one true per list. If several are true, console.error and use the first.
   * Used only as a frontend prefill on blank inventory create.
   */
  getDefaultLifecycleOptionKey(options, settingName) {
    const list = Array.isArray(options) ? options : [];
    const defaults = list.filter(option => option && option.default);
    if (defaults.length > 1) {
      console.error(
        `Multiple default flags in ${settingName}. Using the first ("${defaults[0].key}"). Configure at most one default per list.`
      );
    }
    return defaults.length ? defaults[0].key : null;
  },
  searchNested,
  getProposalsHtml(reservations, router, filters){
    const htmlArr = ['<ul>']
    reservations.forEach(r => {
      const receiptPath = router.resolve({name: 'receipt.view', params: {id: r.inventory.receipt_uuid}}).href
      const itemPath = router.resolve({name: 'inventory.view', params: {id: r.inventory.uuid}}).href
      const salePath =router.resolve({ name: 'sales.view', params: { id: r.auction.uuid }}).href
      const lotPath =router.resolve({ name: 'reservations.view', params: { id: r.uuid }}).href
      let html = `<br><li><a href="${receiptPath}">${r.inventory.receipt.receipt_no}</a> \\ `
      html += `<a href="${itemPath}">${r.inventory.item_no}</a> - `
      html += `<a href="${salePath}">${r.auction.sale_no}</a> - `
      html += `<a href="${lotPath}">${r.lot_no}</a> - `
      html += `${filters.striptags(r.inventory.short_description)} - `
      html += `${filters.proposalStatusSuggestionMap(r.proposal_suggestion)}`
      html += '</li>'
      htmlArr.push(html)

    })
    htmlArr.push('<ul/>')
    return htmlArr.join('')
  },
  async showProposalsConfirmationModal(reservations, confirm, router, filters) {
    return await confirm(i18n.t("Some of selected items are marked to be reoffered on another auction, returned to the seller, or offered to a 3rd party as part of the proposal for unsold lots (Please check Sale > View > Vendors – Proposal of Unsold Lots) and may be waiting for sellers' confirmation before final decision is made:")
      + this.getProposalsHtml(reservations, router, filters),
      null, null, null, i18n.t('Warning'), i18n.t('Proceed'), i18n.t('Cancel'), null,
      {label: i18n.t('Are you sure you would like to proceed?'), text: 'proceed'}, null, 'danger'
    )
  }
}
